import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  makerInfo: {
    marginBottom: theme.spacing(2),
  },
}));
